import { StyledFormGroupError } from 'components/shared/FormGroup.styled';
import styled from 'styled-components';
import { color, container, fontSize, fontWeight, spacing } from 'theme';

export const StyledWrapper = styled.div`
  background-color: ${color('midnight_800')};
  color: ${color('text_default_inverse')};
`;

export const StyledContainer = styled.div`
  max-width: ${container('lg')};
  margin: auto;
  padding: ${spacing('xl5')} ${spacing('md')};
`;

export const StyledHeader = styled.div`
  text-align: center;
  font-size: ${fontSize('lg')};
  line-height: 1.6;
`;

export const StyledForm = styled.form`
  max-width: ${container('md')};
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: ${spacing('xl3')} auto 0;

  ${StyledFormGroupError} {
    position: absolute;
  }
`;

export const StyledFormTitle = styled.p`
  font-size: ${fontSize('lg')};
  line-height: 1.1666;
  font-weight: ${fontWeight('extraBold')};
  margin-top: 0;
  margin-bottom: ${spacing('lg')};
`;

export const StyledFormInputs = styled.div`
  max-width: 19.25rem;
  width: 100%;
  display: flex;
  flex-direction: column;
  gap: ${spacing('xl')};
  margin-bottom: ${spacing('xl')};

  button {
    align-self: flex-start;
    margin-top: ${spacing('xl')};
  }
`;

export const StyledFormTerms = styled.p`
  font-size: ${fontSize('xs')};
  line-height: 1.333;
  margin-top: 0;
  margin-bottom: 0;

  a {
    font-weight: ${fontWeight('black')};
    color: ${color('link_inverse')};

    &:hover,
    &:focus {
      color: ${color('link_inverse_hover')};
    }

    &:active {
      color: ${color('link_inverse_active')};
    }
  }
`;
